import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
const initialState = {
    isOpen: false,
    options: {
        title: undefined,
        content: '',
        isHtmlContent: false,
        cancelButtonLabel: undefined,
        confirmButtonLabel: undefined,
        icon: undefined,
        variant: undefined,
    },
    resolveCallback: () => null,
};
const useConfirmDialogStore = create()(immer((set, get) => ({
    ...initialState,
    openDialog: (options) => set((state) => {
        state.isOpen = true;
        state.options = options;
    }),
    setResolve: (resolveCallback) => set((state) => {
        state.resolveCallback = resolveCallback;
    }),
    onConfirm: () => {
        const { resolveCallback } = get();
        set((state) => {
            state.isOpen = false;
            state.resolveCallback = undefined;
        });
        resolveCallback?.(true);
    },
    onCancel: () => {
        const { resolveCallback } = get();
        set((state) => {
            state.isOpen = false;
            state.resolveCallback = undefined;
        });
        resolveCallback?.(false);
    },
    resetState: () => {
        set(initialState);
    },
})));
export { useConfirmDialogStore };
